var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneRouteStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6976 5.03081L6.69759 13.0308C6.62791 13.1007 6.54512 13.1562 6.45395 13.1941C6.36279 13.2319 6.26505 13.2514 6.16634 13.2514C6.06763 13.2514 5.96989 13.2319 5.87873 13.1941C5.78756 13.1562 5.70477 13.1007 5.63509 13.0308L2.13509 9.53081C2.06533 9.46105 2.00998 9.37823 1.97223 9.28707C1.93447 9.19592 1.91504 9.09823 1.91504 8.99956C1.91504 8.9009 1.93447 8.8032 1.97223 8.71205C2.00998 8.6209 2.06533 8.53808 2.13509 8.46831C2.20485 8.39855 2.28768 8.34321 2.37883 8.30545C2.46998 8.26769 2.56768 8.24826 2.66634 8.24826C2.765 8.24826 2.8627 8.26769 2.95385 8.30545C3.045 8.34321 3.12783 8.39855 3.19759 8.46831L6.16697 11.4377L13.6363 3.96956C13.7772 3.82867 13.9683 3.74951 14.1676 3.74951C14.3668 3.74951 14.5579 3.82867 14.6988 3.96956C14.8397 4.11046 14.9189 4.30156 14.9189 4.50081C14.9189 4.70007 14.8397 4.89117 14.6988 5.03206L14.6976 5.03081Z",
    fill: "#1677FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneRouteStep);
export default __webpack_public_path__ + "static/media/done-route-step.32d7ce97.svg";
export { ForwardRef as ReactComponent };